import './index-edit/endpoint'
import './page-select/endpoint'
import './file-select/endpoint'
import './tag-select/endpoint'
import './nav-edit/endpoint'
import './page-edit/endpoint'
